// extracted by mini-css-extract-plugin
export default {"Faq":"Faq-module__Faq--v9Drr"};